module.exports = __webpack_public_path__ + "static/media/logo_3_success.b2508fcc.png";